import React from "react";
import DefaultButton from "./DefaultButton";
import LinkedButton from "./LinkedButton";
import ErrorComponent from "./ErrorComponent";
import OTPInput from "react-otp-input";

export default function DeccanOtpForm({
  tabDetail,
  reference,
  OTP,
  setOTP,
  otpError,
  setOtpError,
  isDisableVerifyBtn,
  setIsDisableVeifyBtn,
  isDisableResendBtn,
  setIsDisableResendBtn,
  handleOTPInput,
  resendOTP,
  progress,
  pathname,
  setUserOTP,
  userOTP,
  userOtpError,
  setIsDisableUserVerifyBtn,
  isDisableUserVerifyBtn,
  isEmailUpdateOrPhoneNumber,
  setUserOtpError
}) {
  return (
    <div className="lg:px-4">
      <fieldset className="contents" disabled={isDisableVerifyBtn}>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="w-full flex justify-center items-center lg:px-9 md:px-0 sm:px-6 xs:px-4">
            {userOtpError || otpError ? (
              <ErrorComponent
                errorMsg={userOtpError ? userOtpError : otpError}
                onClick={() => {
                 userOtpError ? setUserOtpError("") : setOtpError("");
                }}
                className={"w-[55%] lg:w-full md:w-full sm:w-full xs:w-full"}
              />
            ) : (
              <div className="mt-16"></div>
            )}
          </div>
          <div className="w-full px-16 sm:px-4 md:px-0 lg:px-4 xs:px-1">
            <OTPInput
              onChange={(OTP) => {
                setOtpError(null);
                pathname.includes(isEmailUpdateOrPhoneNumber)
                  ? setUserOTP(OTP)
                  : setOTP(OTP);
              }}
              value={OTP || userOTP}
              inputStyle={{
                width: "30%",
                height: "50px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                marginLeft: "8px",
                marginRight: "8px",
                background: "#FFFFFF",
                fontSize: "16px",
                color: "#374151",
                fontWeight: "400",
                outline: "none",
              }}
              numInputs={6}
              separator={<span></span>}
              renderInput={(props) => <input {...props} />}
              inputType="tel"
            />
          </div>
          <div className="w-full items-center mb-2 mt-4 lg:px-9 md:px-0 sm:px-6 xs:px-4">
            <DefaultButton
              label={"Verify"}
              onClick={handleOTPInput}
              disabled={isDisableVerifyBtn || isDisableUserVerifyBtn}
              className={"w-[55%] lg:w-full md:w-full sm:w-full xs:w-full"}
              type={"submit"}
            />
          </div>
          <div className="w-full items-center mb-4">
            {progress ? (
              <p className="text-gray-400 px-2 py-1">
                Resend OTP in {progress} Sec
              </p>
            ) : (
              <LinkedButton
                label={"Resend OTP"}
                onClick={resendOTP}
                disabled={isDisableResendBtn || isDisableVerifyBtn}
              />
            )}
          </div>
        </form>
      </fieldset>
    </div>
  );
}
